import script from "./ClientCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientCard.vue?vue&type=script&setup=true&lang=js"

import "./ClientCard.vue?vue&type=style&index=0&id=09c04a73&lang=scss"

const __exports__ = script;

export default __exports__